/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Why_Listening_Ai_InsightsInputs */

const en_why_listening_ai_insights = /** @type {(inputs: Why_Listening_Ai_InsightsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI insights`)
};

const es_why_listening_ai_insights = /** @type {(inputs: Why_Listening_Ai_InsightsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Información con IA`)
};

/**
* | output |
* | --- |
* | "AI insights" |
*
* @param {Why_Listening_Ai_InsightsInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const why_listening_ai_insights = /** @type {((inputs?: Why_Listening_Ai_InsightsInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Why_Listening_Ai_InsightsInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_why_listening_ai_insights(inputs)
	return en_why_listening_ai_insights(inputs)
});